enum ProductOrderAttachmentType {
    DELIVERY_EVIDENCE = 'DELIVERY_EVIDENCE',
    DELIVERY_ISSUE = 'DELIVERY_ISSUE',
}

export function translateProductOrderAttachmentType(type: ProductOrderAttachmentType): string {
    switch (type) {
        case ProductOrderAttachmentType.DELIVERY_EVIDENCE:
            return 'Evidencia de entrega';
        case ProductOrderAttachmentType.DELIVERY_ISSUE:
            return 'Problema con la entrega';
    }
}

export default ProductOrderAttachmentType